import request from '@/utils/http';
import { SRM } from '../../constant/constant.js';

// 联系人信息
export const getPersons = (params) => {
    return request({
        url: `${SRM}/queryContactsInfoList`,
        method: 'get',
        params: params
    });
};

// 启用联系人
export const enablePersons = (params) => {
    return request({
        url: `${SRM}/enableContacts`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 停用联系人
export const disablePersons = (params) => {
    return request({
        url: `${SRM}/disableContacts`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 启用联系人账号
export const enableContactsUser = (params) => {
    return request({
        url: `${SRM}/supplierUser/enableContactsUser`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 停用联系人账号
export const disableContactsUser = (params) => {
    return request({
        url: `${SRM}/supplierUser/disableContactsUser`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 删除联系人
export const deletePersons = (params) => {
    return request({
        url: `${SRM}/deleteByIds`,
        method: 'delete',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 生成账号
export const creatAccount = (id, params = {}) => {
    return request({
        url: `${SRM}/addSubUserCodeAndSecretKey/` + id,
        method: 'get',
        params: params
    });
};

// 修改联系人
export const modifyPersons = (id, params) => {
    return request({
        url: `${SRM}/updateUser/` + id,
        method: 'put',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 新增联系人
export const addPersons = (params) => {
    return request({
        url: `${SRM}/createContacts`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 取单条联系人数据
export const singlePersons = (id, params = {}) => {
    return request({
        url: `${SRM}/supplierContactsInfo/` + id,
        method: 'get',
        params: params
    });
};

// 提交角色权限
export const submitRole = (params) => {
    return request({
        url: `${SRM}/grantUserRoles`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 提交数据权限
export const submitData = (params) => {
    return request({
        url: `${SRM}/saveUserDataAuthDetails`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 管理端主账号数据权限列表
export const getAllDataAuth = (params) => {
    return request({
        url: `${SRM}/getAllDataAuth`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 工作台主账号数据权限列表
export const getAllDataAuthOfWorkbench = (params) => {
    return request({
        url: `${SRM}/getDataAuthsFromGrant`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 子账号数据权限列表
export const getDataAuthsFromGrant = (params) => {
    return request({
        url: `${SRM}/querySubDataAuthsGrant`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 主账号角色权限
export const getMainUserGrantRoles = (params) => {
    return request({
        url: `${SRM}/queryMainUserGrantRoles`,
        method: 'get',
        params: params
    });
};

// 子账号角色权限
export const getSubUserGrantRoles = (params) => {
    return request({
        url: `${SRM}/querySubUserGrantRoles`,
        method: 'get',
        params: params
    });
};

// 获取登陆用户的供应商编码
export const getLoginUser = (userCode, params = {}) => {
    return request({
        url: `${SRM}/getSupplierCodeAndPropertyNature/` + userCode,
        method: 'get',
        params: params
    });
};

// 重置密码
export const resetPassword = (params) => {
    return request({
        url: `${SRM}/resetUserPassWord`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 绑定租户
export const bindTenant = (params) => {
    return request({
        url: `${SRM}/createTenantUser `,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 审批详情信息（弹窗）
export const getContactApproveDetail = (params) => {
    return request({
        url: `${SRM}/supplierContactsApproval/getApprovalDetail/${params.supplierCode}/${params.contactsId}`,
        method: 'get'
    });
};

// 联系人审批页面详情
export const getContactApprovePage = (id) => {
    return request({
        url: `${SRM}/supplierContactsApproval/getApprovalFormData/${id}`,
        method: 'get'
    });
};

// 通过联系人审批
export const passContactApprove = (params) => {
    return request({
        url: `${SRM}/supplierContactsApproval/passApproval`,
        method: 'post',
        data: JSON.parse(params),
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 驳回联系人审批
export const refuseContactApprove = (params) => {
    return request({
        url: `${SRM}/supplierContactsApproval/refuseApproval`,
        method: 'post',
        data: JSON.parse(params),
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 判断当前联系人是否有审批
export const existApprovalDetail = (params) => {
    return request({
        url: `${SRM}/supplierContactsApproval/existApprovalDetail/${params.supplierCode}/${params.contactsId}`,
        method: 'get'
    });
};

// 撤回审批
export const revokeApprove = (params) => {
    return request({
        url: `${SRM}/supplierContactsApproval/returnEvent/${params.supplierCode}/${params.contactsId}`,
        method: 'put'
    });
};